<template>
  <a v-if="isExternal" :href="to" target="_blank">
    <div
      class="hit-menu-item text-sidebar hover:text-sidebar hover:bg-sidebar-hover"
    >
      <hit-icon
        v-if="icon"
        class="hit-menu-item-icon"
        :icon="icon"
        :tooltip="iconTooltip"
        color="text-light-2"
      />
      <span
        :class="{show: !collapse, hide: collapse}"
        class="hit-menu-item-label"
        >{{ label }}</span
      >
      <slot />
    </div>
  </a>

  <router-link v-else-if="!hide" :to="to" :replace="replace" event="click">
    <div
      class="hit-menu-item hover:bg-sidebar-hover"
      :class="{
        'text-sidebar-selected': selected,
        'text-sidebar': !selected,
      }"
      @click="onMenuItemClick"
    >
      <hit-icon
        v-if="icon"
        class="hit-menu-item-icon"
        :icon="icon"
        :tooltip="iconTooltip"
      />
      <span
        :class="{show: !collapse, hide: collapse}"
        class="hit-menu-item-label"
        >{{ label }}</span
      >
      <slot />
    </div>
  </router-link>
</template>

<script>
import {HitIcon} from '@hit/components';
export default {
  name: 'HitMenuItem',
  components: {HitIcon},
  props: {
    icon: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    to: {
      type: [Object, String],
      required: false,
    },
    replace: {
      type: Boolean,
      default: false,
    },
    collapse: {
      type: Boolean,
      required: false,
    },
    hide: {
      type: Boolean,
      required: false,
      default: false,
    },
    tooltip: {
      type: String,
      default: null,
    },
    selected: Boolean,
  },
  data: function () {
    return {};
  },
  computed: {
    isExternal() {
      if (typeof this.itemLink !== 'string') {
        return false;
      }
      return (
        this.itemLink.startsWith('http://') ||
        this.itemLink.startsWith('https://')
      );
    },
    itemLink() {
      if (!this.to) {
        return '';
      }
      if (this.to instanceof Object) {
        return this.to.name;
      } else {
        return this.to;
      }
    },
    iconTooltip() {
      if (this.collapse) {
        return [this.label, this.tooltip].join('\n');
      } else {
        return this.tooltip;
      }
    },
  },
  methods: {
    onMenuItemClick: function ($event) {
      this.$emit('click', $event);
    },
  },
  emits: ['click'],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hit-menu-item {
  display: grid;
  grid-template-columns: minmax(min-content, 0) minmax(0, max-content) minmax(
      max-content,
      0
    );
  grid-template-areas: 'icon label';
  @apply p-2 rounded-md;

  .hit-menu-item-icon {
    grid-area: icon;
  }

  .hit-menu-item-label {
    opacity: 1;
    transition: opacity 0.15s ease, visibility 0.15s ease;
    visibility: visible;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    grid-area: label;
    white-space: nowrap;
    @apply grid items-center;
  }

  .hit-menu-item-label.hide {
    opacity: 0;
    visibility: hidden;
    transition-delay: 0.15s;
    width: 0;
    padding-left: 0;
    padding-right: 0;
    overflow: hidden;
  }
}
</style>
